<div id="page-bg">
  <div [class.w-100]="isExtraLarge" class="row">
    <!--        Environment alert section -->
    @if (showEnvironmentMessage && !isProd ) {
      <div class="container-sm">
        <app-message [severity]="alertMessage?.severity" [text]="alertMessage?.text"></app-message>
      </div>
    }
    @if (isExtraLarge) {
      <div class="container">
        <div class="row card-row">
          <div class="col-12 col-xl-10 offset-xl-1">
            <ng-container [ngTemplateOutlet]="mainCard"></ng-container>
          </div>
        </div>
      </div>
    } @else {
      <div class="container-sm">
        <ng-container [ngTemplateOutlet]="mainCard"></ng-container>
      </div>
    }
  </div>
</div>

<ng-template #mainCard>
  <app-alert></app-alert>

  <div [class]="getMainCardSizeClass">
    <div class="card-body">
      <!-- Logo Section -->
      <div class="logo">
        <a [routerLink]="routes.SECURE.HOME.VIEW.path">
          @if (logoOverrideSrc) {
            <img [ngSrc]="logoOverrideSrc" alt="App logo" class="logo-override" width="263" height="40">
          } @else {
            <picture>
              <source [srcset]="logoMobile | assetSource" media="(max-width: 576px)">
              <img [ngSrc]="logoSecondary | assetSource" alt="App logo" height="30" width="40">
            </picture>
          }
        </a>
      </div>

      <!-- Header Section -->
      @if (headerText) {
        <h1 [class]="getHeaderTextClasses">{{ headerText }}</h1>
      }
      @if (showHeaderRule) {
        <hr class="horizontal-bar">
      }
      <br>

      <!-- Dynamic Content Section -->
      <div class="content">
        <ng-content></ng-content>
      </div>

    </div>
  </div>
</ng-template>
